export default __webpack_public_path__ + "d2ce4dab32371a89a3222ac4ad331f2f.png";